<template>
 <div>
   <section class="mobile" style="margin-top: 48px;">
  <p class="m-suggestion-head-copy"><span v-for="(item, index) in cartItems" :key="index">{{item.pureName}}</span>와<br>함께 시너지를 내는 제품들</p>
     <div class="wrapper">
        <tiny-slider :mouse-drag="true" :loop="false" :controls="false" :nav="false" :autoplay="false" :items="1"
                     :edgePadding="40" :gutter="0">
          <div v-for="(suggestion, index) in suggestions" :key="index" class="m-suggestion-items" @click="goProduct(suggestion.suggestionName)" style="cursor: pointer">
            <div class="m-main-copy">
              <p class="bold">{{suggestion.suggestionName}}</p>
              <p>{{suggestion.suggestionDescription}}</p>
            </div>
            <img style="margin-top: 25px" :src="suggestion.suggestionUrl" alt="">
          </div>
        </tiny-slider>
      </div>
   </section>
  <section class="desktop" style="margin-top: 70px;">
  <p class="suggestion-head-copy"><span v-for="(item, index) in cartItems" :key="index">{{item.pureName}}</span>와 함께 시너지를 내는 제품들</p>
  <div class="container">
    <div v-for="(suggestion, index) in suggestions" :key="index" class="suggestion-items" @click="goProduct(suggestion.suggestionName)" style="cursor: pointer">
      <div class="main-copy">
        <p class="bold">{{suggestion.suggestionName}}</p>
        <p>{{suggestion.suggestionDescription}}</p>
      </div>
      <img style="margin-top: 58px" :src="suggestion.suggestionUrl" alt="">
    </div>
  </div>
  </section>
 </div>
</template>

<script>
import VueTinySlider from 'vue-tiny-slider'
export default {
  name: 'suggestion',
  components: {
    'tiny-slider': VueTinySlider
  },
  methods: {
    goProduct: function (name) {
      switch (name) {
        case 'Switcher':
          this.$router.push({ name: 'Switcher' })
          break
        case 'Linker':
          this.$router.push({ name: 'Linker' })
          break
        case 'Checker':
          this.$router.push({ name: 'Checker' })
          break
      }
    }
  },
  computed: {
    suggestions () {
      return this.$store.state.suggestions
    },
    cartItems () {
      return this.$store.state.cartItems
    }
  }
}
</script>

<style scoped>

.suggestion-head-copy {
  font-size: 20px;
  letter-spacing: 0;
}
 .container {
     display: flex;
     justify-content: center;
 }
 .suggestion-items {
   margin: 20px;
   width: 264px;
   height: 370px;
   background-color: #f5f6f7;
   border-radius: 2px;
   border: solid 1px #f5f6f7;
   padding: 42px 28px 0px 28px;
 }
 .suggestion-items:hover {
   box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.13);
 }
 .suggestion-items .main-copy {
   text-align: left;
   font-size: 16px;
 }
 .suggestion-items .main-copy :nth-child(1) {
   margin-bottom: 13px;
 }
 .suggestion-items .main-copy :nth-child(2) {
   margin-bottom: 0;
 }

 .m-suggestion-head-copy {
   font-size: 18px;
 }

 .m-suggestion-items {
    width: 181pt !important;
    background-color: #f5f6f7;
    border-radius: 2px;
    height: 254pt;
    font-family: Arial;
    text-align: center;
    padding: 2em;
    margin: 5px;
    /* margin: 0 auto; */
  }
  .m-suggestion-items .m-main-copy {
    text-align: left;
  }

</style>



// WEBPACK FOOTER //
// src/components/apply/cart/Suggestion.vue